import { Link } from "react-router-dom";
import { exclusiveArticles } from "@/mocks/articles";

export default function ExclusiveSection() {
  const main = exclusiveArticles[0];
  const side = exclusiveArticles.slice(1, 3);

  return (
    <section className="bg-background-50 py-12 md:py-20" aria-label="独家深扒">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight">
            独家
            <br className="hidden md:block" />
            深扒
          </h2>
          <p className="text-sm text-foreground-500 max-w-sm md:text-right">
            十年娱记团队一线追踪，深挖事件背后的完整脉络与隐藏关联
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Main Card - Left */}
          <div className="md:col-span-1 bg-foreground-800 rounded-xl overflow-hidden group cursor-pointer">
            <Link to={`/article/${main.id}`} className="block">
              <div className="p-5">
                <h3 className="text-lg font-bold text-white mb-2 line-clamp-2">
                  {main.title}
                </h3>
                <p className="text-sm text-white/60 line-clamp-3">
                  {main.excerpt}
                </p>
              </div>
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={main.image}
                  alt={main.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <img
                    src={main.authorAvatar}
                    alt={main.author}
                    className="w-6 h-6 rounded-full object-cover"
                  />
                  <span className="text-xs text-white/70">{main.author}</span>
                </div>
                <span className="text-xs text-white/50">{main.publishDate}</span>
              </div>
            </Link>
          </div>

          {/* Side Cards */}
          {side.map((article) => (
            <div
              key={article.id}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer"
            >
              <Link to={`/article/${article.id}`} className="block">
                <div className="p-4 flex items-center gap-2">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-semibold rounded">
                    {article.category}
                  </span>
                  <span className="text-[10px] text-foreground-400">
                    独家
                  </span>
                </div>
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="mt-3 flex items-center gap-2">
                    <img
                      src={article.authorAvatar}
                      alt={article.author}
                      className="w-5 h-5 rounded-full object-cover"
                    />
                    <span className="text-xs text-foreground-400">{article.author}</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}